import { render, staticRenderFns } from "./EditorBlockText.vue?vue&type=template&id=cd6ee16c&scoped=true"
import script from "./EditorBlockText.vue?vue&type=script&lang=js"
export * from "./EditorBlockText.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockText.vue?vue&type=style&index=0&id=cd6ee16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6ee16c",
  null
  
)

export default component.exports